import { useState } from "react";

interface ImagePreviewProps {
  url: string | null;            // full HD presigned URL — null until it's been fetched
  name: string;
  thumbnailUrl?: string | null;  // low-res WebP placeholder while HD loads
}

export function ImagePreview({ url, name, thumbnailUrl }: ImagePreviewProps) {
  const [hdLoaded, setHdLoaded] = useState(false);

  return (
    <div className="relative flex h-full w-full items-center justify-center">
      {/* Thumbnail shown instantly at true size — stays mounted and fades out as the
          HD image fades in, so the swap is a crossfade rather than an abrupt cut. */}
      {thumbnailUrl && (
        <img
          src={thumbnailUrl}
          alt=""
          aria-hidden
          className={`absolute h-full w-full object-contain transition-opacity duration-300 ${
            hdLoaded ? "opacity-0" : "opacity-100"
          }`}
        />
      )}

      {/* Spinner — only when there's genuinely nothing to show yet */}
      {!hdLoaded && !thumbnailUrl && (
        <div className="absolute h-8 w-8 animate-spin rounded-full border-2 border-gray-600 border-t-brand-400" />
      )}

      {/* Full HD image — mounts once the presigned URL resolves, fades in once decoded */}
      {url && (
        <img
          src={url}
          alt={name}
          className={`relative h-full w-full object-contain shadow-2xl transition-opacity duration-300 ${
            hdLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setHdLoaded(true)}
        />
      )}
    </div>
  );
}
